import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M17.37 3.16c-.18-.2-.49-.22-.69-.04s-.22.49-.04.69c.24.27.38.62.38.98v12.75c0 .81-.66 1.47-1.46 1.47H4.82c-.37 0-.73-.14-1-.4-.2-.19-.5-.18-.69.02-.18.2-.18.51.02.69.46.44 1.05.68 1.67.68h10.74c1.35 0 2.44-1.1 2.44-2.45V4.8c0-.6-.22-1.19-.63-1.64z',
    'M16 16V3c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2zM3 2h11c.55 0 1 .45 1 1v1H2V3c0-.55.45-1 1-1zM2 16V5h13v11c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1z',
    'M12.47 7H4.53c-.29 0-.53.22-.53.5s.24.5.53.5h7.94c.29 0 .53-.22.53-.5s-.24-.5-.53-.5zM12.47 9H4.53c-.29 0-.53.22-.53.5s.24.5.53.5h7.94c.29 0 .53-.22.53-.5s-.24-.5-.53-.5zM12.47 11H4.53c-.29 0-.53.22-.53.5s.24.5.53.5h7.94c.29 0 .53-.22.53-.5s-.24-.5-.53-.5zM8.47 13H4.53c-.29 0-.53.22-.53.5s.24.5.53.5h3.94c.29 0 .53-.22.53-.5s-.24-.5-.53-.5z',
  ],
  height: 20,
  width: 20,
});
